<script>
	import { onMount, onDestroy } from 'svelte';
	import { auth, db } from './firebase/firebase.config.js';

	let theme = "g10";

	// Methods
	import getData from './methods/getData.js';
	import getExpenseHistory from './methods/getExpenseHistory.js';
	
	// Stores
    import {UserStore, BankStore} from './store';
	
	// Custom Components
	import Index from './components/Index.svelte';


	// Life-Cycle Hooks
	
	onMount(() => {
		getData;
        getExpenseHistory;
	});
</script>

<style global lang="scss">
	@import "carbon-components-svelte/css/g10";
	@import './assets/scss/styles.scss';
</style>

<Index />